import { useQuery } from '@tanstack/react-query';
import billerHttp from '../../../utils/billerHttp';

export function useGeAllClaims() {
  const { data, isLoading, ...rest } = useQuery({
    queryKey: ["get all claims by status"],
    queryFn: async () => {
      const response = await billerHttp.get(`billers/claims/status`);
      return response.data;
    },
    staleTime: Infinity,
  });
  return {
    allClaims: data?.claimsByStatus,
    isLoading,
    ...rest,
  }
}